import { forwardRef, HTMLAttributes } from 'react'
import { cn } from '../../utils'

export type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
	as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

// todo: refaco Heading cmp to Hn
export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
	(
		{ children, dangerouslySetInnerHTML, as = 'h1', className, ...rest },
		ref,
	) => {
		const Component = as
		return (
			<Component
				ref={ref}
				className={cn('text-balance', className)}
				dangerouslySetInnerHTML={dangerouslySetInnerHTML}
				{...rest}
			>
				{children}
			</Component>
		)
	},
)

Heading.displayName = 'Heading'
